import { Button, Popconfirm } from 'antd';
import PropTypes from 'prop-types';

import './index.scss';

/* Both actions are irreversible from the client's side - one hands the order to
 * the rep, the other empties the basket - so both ask first. */
const ButtonSection = ({
  submitTitle,
  cancelTitle,
  submitConfirmText,
  confirmText,
  cancelText,
  okText,
  onSubmit,
  onCancel,
  disabled,
  skipSubmitConfirm = false,
  submitLoading = false,
}) => (
  <div className="buttons-wrapper">
    {/* Some orders confirm in a dialog of their own further on, and asking here as
        well would make the client agree to the same thing twice. The button is
        rendered bare in that case rather than inside a disabled Popconfirm, so
        submitting does not rest on the click handler surviving antd's cloneElement.

        That is also the path with nothing between the click and a round trip to
        the API, so it is the one that carries the spinner. */}
    {skipSubmitConfirm ? (
      <Button type="primary" disabled={disabled} loading={submitLoading} onClick={onSubmit}>
        {submitTitle}
      </Button>
    ) : (
      <Popconfirm
        onConfirm={onSubmit}
        title={submitConfirmText}
        cancelText={cancelText}
        okText={okText}
        placement="top"
        disabled={disabled}
      >
        <Button type="primary" disabled={disabled} loading={submitLoading}>
          {submitTitle}
        </Button>
      </Popconfirm>
    )}
    <Popconfirm
      onConfirm={onCancel}
      title={confirmText}
      cancelText={cancelText}
      okText={okText}
      placement="top"
      disabled={disabled}
    >
      <Button type="primary" danger disabled={disabled}>
        {cancelTitle}
      </Button>
    </Popconfirm>
  </div>
);

ButtonSection.propTypes = {
  submitTitle: PropTypes.string,
  cancelTitle: PropTypes.string,
  submitConfirmText: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  okText: PropTypes.string,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  disabled: PropTypes.bool,
  skipSubmitConfirm: PropTypes.bool,
  submitLoading: PropTypes.bool,
};

export default ButtonSection;
